import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=fbdd5a74&scoped=true&"
import script from "./DashboardTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTable.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DashboardTable.vue?vue&type=style&index=0&id=fbdd5a74&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fbdd5a74",
  null
  ,true
)

export default component.exports